/** Reporting UI icons — filled / solid only (no Ant Design Outlined). */
import {
    PlusCircleFilled,
    DeleteFilled,
    EditFilled,
    DatabaseFilled,
    CodeFilled,
    CheckCircleFilled,
    ExclamationCircleFilled,
    BulbFilled,
    ThunderboltFilled,
    CopyFilled,
    PieChartFilled,
    ProfileFilled,
    FileImageFilled,
    SaveFilled,
    SettingFilled,
    PlusSquareFilled,
} from '@ant-design/icons';
import {
    FaArrowsRotate,
    FaMagnifyingGlass,
    FaChartColumn,
    FaChartLine,
    FaChartPie,
    FaBarsProgress,
    FaTable,
    FaDownload,
    FaUpRightAndDownLeftFromCenter,
    FaExpand,
    FaCompress,
    FaHashtag,
} from 'react-icons/fa6';

export const IconAdd = PlusCircleFilled;
export const IconDelete = DeleteFilled;
export const IconEdit = EditFilled;
export const IconDatabase = DatabaseFilled;
export const IconCode = CodeFilled;
export const IconCheck = CheckCircleFilled;
export const IconWarning = ExclamationCircleFilled;
export const IconBulb = BulbFilled;
export const IconDetect = ThunderboltFilled;
export const IconDeploy = ThunderboltFilled;
export const IconCopy = CopyFilled;
export const IconChart = PieChartFilled;
export const IconChartBar = FaChartColumn;
export const IconChartBarHorizontal = FaBarsProgress;
export const IconChartLine = FaChartLine;
export const IconChartPie = FaChartPie;
export const IconTable = FaTable;
export const IconTableAlt = ProfileFilled;
export const IconDownload = FaDownload;
export const IconExpand = FaUpRightAndDownLeftFromCenter;
export const IconMaximize = FaExpand;
export const IconCompress = FaCompress;
export const IconStat = FaHashtag;
export const IconSave = SaveFilled;
export const IconExportCsv = SaveFilled;
export const IconExportPng = FileImageFilled;
export const IconDashboard = PlusSquareFilled;
export const IconReload = FaArrowsRotate;
export const IconSearch = FaMagnifyingGlass;
export const IconSettings = SettingFilled;

export { isDescriptorValid, descriptorValidationMessage } from './reportingFunctionContract';
